import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GECKO_CONSTS, GeckoField } from 'ui';
import AsyncSelect from 'components/AsyncSelect';

class FieldSelect extends Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    multi: PropTypes.bool,
    placeholder: PropTypes.string,
    onFieldSelected: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      fieldMap: {},
      shouldFireFirstSelect: !!props.value,
    };
  }

  handleChange(_key, value) {
    this.props.onChange(value);
    if (this.props.onFieldSelected) {
      const field = this.state.fieldMap[value];
      this.props.onFieldSelected(field);
    }
  }

  updateFieldMap(options) {
    const newFieldMap = options.reduce((fieldMap, option) => {
      const { field } = option;
      return Object.assign({}, fieldMap, { [field.id]: field });
    }, this.state.fieldMap);
    this.setState({ fieldMap: newFieldMap }, () => {
      if (this.state.shouldFireFirstSelect) {
        const field = this.state.fieldMap[this.props.value];
        this.props.onFieldSelected(field);
        this.setState({ shouldFireFirstSelect: false });
      }
    });
  }

  render() {
    const field = {
      key: 'value',
      type: GECKO_CONSTS.FIELD_TYPE_CUSTOM,
      component: (
        <AsyncSelect
          multi={this.props.multi}
          placeholder={this.props.placeholder}
          getUrl="/fields"
          selectUrl="/fields"
          optionTransform={(field) => ({
            label: field.label,
            value: field.id,
            field,
          })}
          onOptionsUpdated={this.updateFieldMap.bind(this)}
        />
      ),
    };
    return (
      <div className="FieldSelect">
        <GeckoField
          field={field}
          values={{ value: this.props.value }}
          handler={this.handleChange.bind(this)}
        />
      </div>
    );
  }
}

export default FieldSelect;
